import {mapState} from 'vuex';


export default{
  name: 'Toast',
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      //show: false
    }
  },
  computed: mapState({
    toast: state => state.toast
  }),
  methods: {

  },
  created() {
		
  }
}


// WEBPACK FOOTER //
// ./src/components/public/toast/Toast.js